import React, { useState, useEffect } from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

const BackendStatus = () => {
  const [backendStatus, setBackendStatus] = useState('checking');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const checkBackend = async () => {
      try {
        const API_BASE = process.env.REACT_APP_API_URL || '';
        const response = await fetch(`${API_BASE}/api/health`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          setBackendStatus('connected');
          setErrorMessage('');
        } else {
          setBackendStatus('error');
          setErrorMessage('Backend server returned an error');
        }
      } catch (error) {
        setBackendStatus('error');
        setErrorMessage('Cannot connect to backend server. Please make sure the server is running.');
        console.error('Backend connection error:', error);
        
        // Show toast notification
        toast.error('Backend server is not connected. Some features may not work.', {
          duration: 5000,
          id: 'backend-error'
        });
      }
    };

    checkBackend();
    // Check every 30 seconds
    const interval = setInterval(checkBackend, 30000);
    
    return () => clearInterval(interval);
  }, []);

  if (backendStatus === 'checking') {
    return null; // Don't show anything while checking
  }

  if (backendStatus === 'error') {
    return (
      <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
        <div className="flex items-center">
          <ExclamationTriangleIcon className="h-5 w-5 text-red-500 mr-2" />
          <div className="flex-1">
            <p className="text-sm font-semibold text-red-800">
              Backend Server Connection Error
            </p>
            <p className="text-sm text-red-700 mt-1">
              {errorMessage}
            </p>
            <p className="text-xs text-red-600 mt-2">
              Please check:
              <br />• Backend server is running on port 3000
              <br />• Database is connected
              <br />• Check server terminal for error messages
            </p>
          </div>
        </div>
      </div>
    );
  }

  return null; // Connected, no need to show anything
};

export default BackendStatus;



